import { Link } from "react-router-dom";
import { BRAND } from "@/config/site";

export const SiteFooter = ({ tone = "dark" }) => (
  <footer
    data-testid="site-footer"
    className={`px-5 py-10 text-xs leading-relaxed sm:px-10 ${
      tone === "dark" ? "bg-navy-deep text-ivory/50" : "text-navy/50"
    }`}
  >
    <div className="mx-auto flex max-w-6xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <p>
        © {new Date().getFullYear()} {BRAND.name}, un service de Vikora AI LLC. Nous ne vendons pas de billets et ne prenons
        aucune réservation.
      </p>
      <div className="flex flex-wrap gap-x-5 gap-y-2">
        <Link to="/mentions-legales" data-testid="footer-legal-link" className="underline underline-offset-2 hover:opacity-80">Mentions légales</Link>
        <Link to="/garantie" data-testid="footer-guarantee-link" className="underline underline-offset-2 hover:opacity-80">Conditions de la garantie</Link>
        <Link to="/confidentialite" data-testid="footer-privacy-link" className="underline underline-offset-2 hover:opacity-80">Confidentialité</Link>
      </div>
    </div>
  </footer>
);
